import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';
import { t } from '../../constants/translationHelper';

const DeleteAlert = ({ open, handleClose, handleDelete, rowId }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t("Confirm Deletion")}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("Are you sure you want to delete this item? This action cannot be undone")}.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('Cancel')}
        </Button>
        <Button onClick={() => handleDelete(rowId)} color="secondary" autoFocus>
          {t("Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAlert;
